/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingViewKey {
  static readonly EMPLOYEE_TIME_RECORDING = 'time-recording/view/employee-time-recording';
  static readonly TIME_RECORDING_TABLE = 'time-recording/view/time-recording-table';
  static readonly TIME_RECORDING_MENU = 'time-recording/view/time-recording-menu';
  static readonly TIME_RECORDING_WORKING_HOURS = 'time-recording/view/time-recording-working-hours';
  static readonly EMPLOYEE = 'time-recording/view/employee';
  static readonly USER = 'time-recording/view/user';
  static readonly PROJECT = 'time-recording/view/project';
  static readonly DELETE_PROJECT_DIALOG = 'time-recording/view/delete-project-dialog';
  static readonly EDIT_ACITIVTY_TOKENS_DIALOG = 'time-recording/view/edit-activity-tokens-dialog';
}
